import styled from 'styled-components';

export default styled.div`
  #ls-status-banner {
    height: auto !important;
  }
`;
